<script>
import api from './api'
export default {
  flushAll () {
    return api.delete('cache')
  }
}
</script>
